// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CONVERT_TO_ASM_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CONVERT_TO_ASM,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input files': {
        systemName: 'Input files',
        displayName: 'Input files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output files': {
        systemName: 'Output files',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      asmVendor: {
        kind: 'enum',
        required: true,
        choices: [
          {
            value: 'AGILENT_GEN5',
            displayName: 'Agilent Gen5'
          },
          {
            value: 'AGILENT_GEN5_IMAGE',
            displayName: 'Agilent Gen5 Image'
          },
          {
            value: 'AGILENT_OPENLAB_CDS',
            displayName: 'Agilent OpenLab CDS'
          },
          {
            value: 'AGILENT_TAPESTATION_ANALYSIS',
            displayName: 'Agilent TapeStation Analysis'
          },
          {
            value: 'APPBIO_ABSOLUTE_Q',
            displayName: 'AppBio AbsoluteQ'
          },
          {
            value: 'APPBIO_QUANTSTUDIO',
            displayName: 'AppBio QuantStudio RT-PCR'
          },
          {
            value: 'APPBIO_QUANTSTUDIO_DESIGNANDANALYSIS',
            displayName: 'AppBio QuantStudio Design & Analysis'
          },
          {
            value: 'BENCHLING_EMPOWER',
            displayName: 'Benchling Waters Empower Adapter'
          },
          {
            value: 'BECKMAN_COULTER_BIOMEK',
            displayName: 'Beckman Coulter Biomek'
          },
          {
            value: 'BECKMAN_ECHO_PLATE_REFORMAT',
            displayName: 'Beckman Echo Plate Reformat'
          },
          {
            value: 'BMG_LABTECH_SMART_CONTROL',
            displayName: 'BMG Labtech SMART Control'
          },
          {
            value: 'BMG_MARS',
            displayName: 'BMG Labtech MARS'
          },
          {
            value: 'BECKMAN_PHARMSPEC',
            displayName: 'Beckman Coulter PharmSpec'
          },
          {
            value: 'BECKMAN_VI_CELL_BLU',
            displayName: 'Beckman Coulter Vi-Cell BLU'
          },
          {
            value: 'BECKMAN_VI_CELL_XR',
            displayName: 'Beckman Coulter Vi-Cell XR'
          },
          {
            value: 'BD_BIOSCIENCES_FACSDIVA',
            displayName: 'BD Biosciences FACSDiva'
          },
          {
            value: 'BIORAD_BIOPLEX',
            displayName: 'Bio-Rad Bio-Plex Manager'
          },
          {
            value: 'CFXMAESTRO',
            displayName: 'Bio-Rad CFX Maestro'
          },
          {
            value: 'CHEMOMETEC_NC_VIEW',
            displayName: 'ChemoMetec NC View'
          },
          {
            value: 'CHEMOMETEC_NUCLEOVIEW',
            displayName: 'ChemoMetec Nucleoview'
          },
          {
            value: 'CTL_IMMUNOSPOT',
            displayName: 'CTL ImmunoSpot'
          },
          {
            value: 'CYTIVA_BIACORE_INSIGHT',
            displayName: 'Cytiva Biacore Insight'
          },
          {
            value: 'CYTIVA_BIACORE_T200_CONTROL',
            displayName: 'Cytiva Biacore T200 Control'
          },
          {
            value: 'CYTIVA_BIACORE_T200_EVALUATION',
            displayName: 'Cytiva Biacore T200 Evaluation'
          },
          {
            value: 'CYTIVA_UNICORN',
            displayName: 'Cytiva Unicorn'
          },
          {
            value: 'FLOWJO',
            displayName: 'FlowJo'
          },
          {
            value: 'LUMINEX_INTELLIFLEX',
            displayName: 'Luminex INTELLIFLEX'
          },
          {
            value: 'LUMINEX_XPONENT',
            displayName: 'Luminex xPONENT'
          },
          {
            value: 'MABTECH_APEX',
            displayName: 'Mabtech Apex'
          },
          {
            value: 'METHODICAL_MIND',
            displayName: 'MSD Methodical Mind'
          },
          {
            value: 'MOLDEV_SOFTMAX_PRO',
            displayName: 'Molecular Devices SoftMax Pro'
          },
          {
            value: 'MSD_WORKBENCH',
            displayName: 'MSD Discovery Workbench'
          },
          {
            value: 'REVVITY_MATRIX',
            displayName: 'Revvity Matrix'
          },
          {
            value: 'NOVABIO_FLEX2',
            displayName: 'NovaBio Flex2'
          },
          {
            value: 'PERKIN_ELMER_ENVISION',
            displayName: 'PerkinElmer Envision'
          },
          {
            value: 'QIACUITY_DPCR',
            displayName: 'Qiacuity dPCR'
          },
          {
            value: 'REVVITY_KALEIDO',
            displayName: 'Revvity Kaleido'
          },
          {
            value: 'ROCHE_CEDEX_BIOHT',
            displayName: 'Roche Cedex BioHT'
          },
          {
            value: 'ROCHE_CEDEX_HIRES',
            displayName: 'Roche Cedex HiRes'
          },
          {
            value: 'TECAN_MAGELLAN',
            displayName: 'Tecan Magellan'
          },
          {
            value: 'BENCHLING_CHROMELEON',
            displayName: 'Benchling Thermo Fisher Scientific Chromeleon'
          },
          {
            value: 'THERMO_FISHER_GENESYS30',
            displayName: 'Thermo Fisher Scientific Genesys30'
          },
          {
            value: 'THERMO_FISHER_GENESYS_ON_BOARD',
            displayName: 'Thermo Fisher Scientific Genesys On-Board'
          },
          {
            value: 'THERMO_FISHER_NANODROP_8000',
            displayName: 'Thermo Fisher Scientific NanoDrop 8000'
          },
          {
            value: 'THERMO_FISHER_NANODROP_EIGHT',
            displayName: 'Thermo Fisher Scientific NanoDrop Eight'
          },
          {
            value: 'THERMO_FISHER_NANODROP_ONE',
            displayName: 'Thermo Fisher Scientific Nanodrop One'
          },
          {
            value: 'THERMO_FISHER_QUBIT4',
            displayName: 'Thermo Fisher Scientific Qubit 4'
          },
          {
            value: 'THERMO_FISHER_QUBIT_FLEX',
            displayName: 'Thermo Fisher Scientific Qubit Flex'
          },
          {
            value: 'THERMO_FISHER_VISIONLITE',
            displayName: 'Thermo Fisher Scientific VISIONlite'
          },
          {
            value: 'THERMO_SKANIT',
            displayName: 'Thermo Fisher Scientific SkanIt'
          },
          {
            value: 'UNCHAINED_LABS_LUNATIC',
            displayName: 'Unchained Labs Lunatic & Stunner'
          }
        ]
      },
      transformType: {
        kind: 'enum',
        required: false,
        choices: [
          {
            value: 'ALLOTROPE',
            displayName: 'Allotrope'
          },
          {
            value: 'ANALYTE',
            displayName: 'Analyte'
          },
          {
            value: 'COMPENSATION',
            displayName: 'Compensation'
          },
          {
            value: 'DATACUBE',
            displayName: 'Datacube'
          },
          {
            value: 'FRACTIONS',
            displayName: 'Fractions'
          },
          {
            value: 'GROUP',
            displayName: 'Group'
          },
          {
            value: 'INJECTIONS',
            displayName: 'Injections'
          },
          {
            value: 'LOG',
            displayName: 'Log'
          },
          {
            value: 'MEASUREMENT',
            displayName: 'Measurement'
          },
          {
            value: 'MEASUREMENT_SEPARATE_UNIT_COLUMN',
            displayName: 'Measurement Separate Unit Column'
          },
          {
            value: 'ORIGINAL',
            displayName: 'Original'
          },
          {
            value: 'PEAKS',
            displayName: 'Peaks'
          },
          {
            value: 'PROCESSED',
            displayName: 'Processed'
          },
          {
            value: 'POPULATION',
            displayName: 'Population'
          },
          {
            value: 'REGION',
            displayName: 'Region'
          },
          {
            value: 'REPORT_POINT',
            displayName: 'Report Point'
          },
          {
            value: 'REPORT',
            displayName: 'Report'
          },
          {
            value: 'SAMPLE',
            displayName: 'Sample'
          },
          {
            value: 'SAMPLE_SEPARATE_UNIT_COLUMN',
            displayName: 'Sample Separate Unit Column'
          },
          {
            value: 'STATISTICS',
            displayName: 'Statistics'
          },
          {
            value: 'TIMESERIES',
            displayName: 'Timeseries'
          },
          {
            value: 'WELL',
            displayName: 'Well'
          }
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
